<template>
  <a-drawer placement="right" :closable="false" :visible="showDrawer" @close="onClose" width="70%"
    :style="{ transform: 'none' }">
    <a-spin v-if="loading" size="large" class="loading" />
    <div v-else>
      <a class="close-img" @click="onClose" style="z-index: 9999;">
        <img src="../../../../public/close.png" alt="" />
      </a>
      <div ref="headRef"></div>
      <div class="header">
        <div class="title">
          {{ userId ? '修改老师' : '新建老师' }}
        </div>
      </div>
      <div>
        <div class="header" v-if="this.state.status === 2" style="justify-content: flex-start;padding-bottom: 20px;">
          <img class="pic1" referrerpolicy="no-referrer" src="/icon/reg/reject.png" />
          <div class="wrap1">
            <span class="word3">审核未通过</span>
            <span class="word4" style="display: block">不通过原因：{{ state.failReason }}</span>
            <span class="word4" style="display: block">审核时间：{{ state.failExamineDate }}</span>
            <span v-if="state.hasAttachment" class="word4" style="display: block">附件：{{ state.fileUrl }}
              <a :href="rootUrl + fileurl" :download="rootUrl + fileurl"
                style="margin-left: 25px">下载</a></span>
          </div>
        </div>
        <div style="padding: 25px 0 0 24px;">
          <TeacherInfo ref="teacherInfoRef" :scene="3" :state="state" :userId="userId"
            :requiredSettingList="requiredSetting" @handleClose="closeDrawer($event)" :showBtn="showBtn"></TeacherInfo>
        </div>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import teacher from '../../../api/teacher'
import school from '../../../api/school'
import TeacherInfo from './TeacherInfo.vue'
import Vue from 'vue'
export default {
  name: "SchoolTeacherForm",
  props: {
    showDrawer: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      state: {
        gender: 1,
        intro: '',
        degreeCertificatList: [
          {
            photoUrl: '',
            photoUrlList: [],
            text: '',
            eduBackground: '',
            photoUrl2: '',
            photoUrl2List: []
          }
        ],
      },
      reqDesc: {
        protraitPhotoUrl: '',
        cardFrontUrl: '',
        cardBackUrl: '',
        avatarUrl: '',
        healthCertificateUrl: [],
        noCriminalUrl: '',
        credentialInfoUrlList: [],
        experience: [],
        talkingVideoUrl: '',
      },
      educationSelect: ['专科', '本科', '研究生', '博士', '其他'],
      addCount: 0,
      sourceFileList: [],
      bureauId: '',
      loading: false,
      status: 0,
      sourceFileList_cardBackUrl: [],
      sourceFileList_cardFrontUrl: [],
      sourceFileList_fullFaced: [],
      sourceFileList_avatarUrl: [],
      sourceFileList_noCriminalUrl: [],
      sourceFileListTalkingVideoUrl: [],
      requiredSetting: [],
      showBtn: false,
      rootUrl: '', // 基地址
      fileurl: '',
    }
  },
  components: {
    TeacherInfo
  },
  created() {
    this.init()
    this.getBtnStatus()
    this.getHostUrl();
  },
  mounted() {
  },
  methods: {
    getHostUrl() {
      this.rootUrl = globalConfig.rootUrl + "/api/bureau/aliyun/getFile?url=";
    },
    getBtnStatus() {
      let key = Vue.ls.get('roleId') == 3 ? 'school_teacher_status' : 'noSchool_teacher_status'
      this.showBtn = this.$ls.get('teaBureauSetting').find(item => item.settingKey == key).settingValue == '1' ? true : false
    },
    init(id) {
      this.getTeacherRequiredFields()
      if (id) {
        this.getTeacherInfo(id)
      }
    },
    backTop() {
      this.$nextTick(() => {
        this.$refs.headRef.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        this.$refs.teacherInfoRef.addListener()
      })
    },
    getTeacherInfo(id) {
      teacher.getTeacherDetail({ userId: id }).then(res => {
        this.fileurl = res.data.fileUrl ? res.data.fileUrl : ''
        this.state = res.data
        this.$refs.teacherInfoRef.dataBack(res.data)
      })
    },
    getTeacherRequiredFields() {
      let type = Vue.ls.get('roleId') == 3 ? 1 : 2 // 1学校 2机构
      school.getTeacherRequiredFields({ type }).then(res => {
        this.requiredSetting = res.data.settingKeyValueDTOS
      })
    },
    download() {
      teacher.getFile()
    },
    onClose() {
      this.$refs.teacherInfoRef.close()
    },
    closeDrawer(flag) {
      this.state = {
        gender: 1,
        intro: '',
        degreeCertificatList: [
          {
            photoUrl: '',
            photoUrlList: [],
            text: '',
            eduBackground: '',
            photoUrl2: '',
            photoUrl2List: []
          }
        ],
      }
      this.$emit("update:showDrawer", false);
      if (flag == 'finish') {
        this.$emit('refresh')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .ant-drawer-body {
  font-family: PingFangSC, PingFang SC;
  padding: 0;
}

.ant-row {
  width: 100%;
}

::v-deep .ant-divider {
  margin: 10px 0;
  background-color: #f0f3fb !important;
}

.close-img {
  position: absolute;
  top: 20px;
  right: 26px;
}

.loading {
  height: 100vh;
  width: 100%;
  padding-top: 35%;
}

.header {
  // position: relative;
  position: fixed;
  top: 0;
  z-index: 999;
  background: #F1F6FC;
  width: calc(70vw - 12px);
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 70px 0 24px;

  .title {
    font-weight: 600;
    font-size: 16px;
    color: #1B1D26;
  }

  .wrap1 {
    margin-left: 24px;
  }
}
</style>